// utils/cdn.ts
const CDN_BASE = 'https://procuzystorage.procuzy.com/elephant-org/';
// mapping for different asset categories
export const ASSET_PATHS = {
    audio: 'media/audio/',
    images: 'media/images/',
    admin: 'media/images/admin/',
    icons: 'media/images/icons/',
    logos: 'media/images/logos/',
    integrations: 'media/images/admin/integrations/',
    lotties: 'media/lotties/',
    admin_whatsapp: 'media/images/admin/integrations/whatsapp/',
    machines: 'media/images/machines/',
    // add more if needed...
};
// export const cdnUrl = (path: string) => `${CDN_BASE}${path}`;
export const cdnUrl = (file, category = 'icons') => {
    return `${CDN_BASE}${ASSET_PATHS[category]}${file}`;
};
